class PasswordTicker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupTickerSpeed () {
    const tickerWidth = this.els.items.element.offsetWidth / 20
    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }
}

if (!customElements.get('password-ticker')) {
  customElements.define('password-ticker', PasswordTicker)
}
